import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.css";

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["remove_button"]
    });
  }

  disconnect() {
    if (this.select) {
      this.select.destroy();
    }
  }
}
